/* global $ */

class Browser {
  constructor(blocks) {
    this.blocks = blocks;

    this.$modal = $('#blocksBrowserModal');

    this.$blocksContainer = this.$modal.find('.js-blocks-browser-container');

    this.$blocksContainer.html(this.blocks.reduce((acc, block) => (
      acc + Browser.renderBlock(block)
    ), ''));
  }

  /**
   * Render block element button
   * @param {Object} data
   * @return {String}
   */
  static renderBlock(data) {
    return `
      <button class="blocks-browser__block" type="button" data-block="${data.id}">
        <i class="fas fa-${data.icon}"></i>
        <span class="text-truncate d-block">${data.name}</span>
      </button>
    `;
  }

  /**
   * Open the block browser
   * @return {Promise}
   */
  open() {
    return this.createBrowser();
  }

  /**
   * Get a block object from the available blocks by id
   * @param {String|Number} id
   * @return {Object}
   */
  getBlock(id) {
    const blocksMatchingId = this.blocks.filter(item => item.id === id);
    return blocksMatchingId.length ? blocksMatchingId[0] : {};
  }

  /**
   * Create the block browser
   * @return {Promise}
   */
  createBrowser() {
    return new Promise((resolve, reject) => {
      // Listen for clicks on the blocks buttons
      this.$blocksContainer.on('click', 'button', (e) => {
        // Get the block object
        const block = this.getBlock($(e.currentTarget).data('block'));

        // Hide the modal
        this.$modal.modal('hide');

        // Send the object back
        resolve(block);
      });

      // Listen for the dissapearance of the modal and remove event listeners
      this.$modal.one('hidden.bs.modal', () => {
        this.$blocksContainer.off('click', 'button');
        reject();
      });

      // Show the blocks modal
      this.$modal.modal('show');
    });
  }
}

export default Browser;
